import {ValueObject} from '@s-ui/domain'

export class OfferPriceValueObject extends ValueObject {
  #offerPrice
  #discountPercentage
  #manufacturerPrice

  constructor({offerPrice, discountPercentage, manufacturerPrice}) {
    super()
    this.#offerPrice = offerPrice
    this.#discountPercentage = discountPercentage
    this.#manufacturerPrice = manufacturerPrice
  }

  static createFromApi({offerPrice, manufacturerPrice}) {
    if (!offerPrice) return

    const getDiscountPercentage = ({price, offerPrice}) => {
      return Math.round(((price - offerPrice) / price) * 100)
    }

    return OfferPriceValueObject.create({
      offerPrice,
      discountPercentage: getDiscountPercentage({
        price: manufacturerPrice,
        offerPrice
      }),
      manufacturerPrice
    })
  }

  static create({offerPrice, discountPercentage, manufacturerPrice}) {
    return new OfferPriceValueObject({
      offerPrice,
      discountPercentage,
      manufacturerPrice
    })
  }

  get offerPrice() {
    return this.#offerPrice
  }

  get discountPercentage() {
    return this.#discountPercentage
  }

  getDiscountPercentageLiteral() {
    return `-${this.#discountPercentage}%`
  }

  get manufacturerPrice() {
    return this.#manufacturerPrice
  }

  get value() {
    return {
      offerPrice: this.#offerPrice,
      discountPercentage: this.#discountPercentage,
      manufacturerPrice: this.#manufacturerPrice
    }
  }
}
